var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications-container"},[_c('v-slide-y-transition',{attrs:{"group":""}},_vm._l((_vm.notifications),function(notification){return _c('NotificationAlert',{key:notification.id,attrs:{"notification":notification}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }